'use client'

import { useAuth } from '@/components/AuthProvider'
import { Button } from '@/components/ui/Button'
import { Crown } from 'lucide-react'
import Link from 'next/link'
import { useState } from 'react'

const apiBase = () => (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/+$/, '')

export function NavUpgradeButton() {
  const { user } = useAuth()
  const [loading, setLoading] = useState(false)

  // Pro from referral days alone has no subscription to manage: keep Upgrade.
  if (user?.subscriptionTier === 'subscriber' && user.proSource !== 'referral') {
    return (
      <Button
        variant="primary"
        size="sm"
        disabled={loading}
        onClick={async () => {
          setLoading(true)
          try {
            const { fetchAuthSession } = await import('aws-amplify/auth')
            const session = await fetchAuthSession()
            const token = session.tokens?.idToken?.toString()
            if (!token) return
            const res = await fetch(`${apiBase()}/billing/portal`, {
              method: 'POST',
              headers: { Authorization: `Bearer ${token}` },
            })
            const body = await res.json().catch(() => null)
            if (res.ok && body?.url) window.location.href = body.url
          } catch {} finally { setLoading(false) }
        }}
      >
        {loading ? 'Loading…' : 'Manage'}
      </Button>
    )
  }

  return (
    <Link href="/pricing">
      <Button variant="primary" size="sm" className="flex items-center gap-2">
        <Crown className="w-4 h-4 hidden sm:block" />
        <span>Upgrade</span>
      </Button>
    </Link>
  )
}
